import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
  Pagination,
} from "@mui/material";
import { getOrders } from '../Redux/Mycart/action';
import { storage } from '../Config/Storage';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Components/Loader';
import Empty from '../Components/Empty';
import Styles from '../Config/Styles';
import Tablehead from '../Components/TableHead';

const Orders = () => {
  const { allorders, value } = useSelector((state) => state?.CartData) || [];
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    dispatch(getOrders({ id: storage.fetch.phone(), status: value, page: page }, setLoading))

  }, [page, value])
  useEffect(() => {

    setPages(Math.ceil(parseInt(allorders?.total) / 5))
  }, [allorders, pages, page])


  const handlePageChange = (event, value) => {
    setLoading(true)
    setPage(value)
  }

  return (
    <>
      <Loader open={loading} />
      {!allorders?.data?.length ? <Empty name={"Orders"} /> :
        <>
          <TableContainer sx={Styles.order.container}>
            <Table>
              <Tablehead data={["Product name", "Quantity", "Details", "Status"]} />
              <TableBody>

                {allorders?.data?.map((order, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box sx={Styles.order.box}>
                        <img src={`https://api-dev.tabta.net/assets/${order?.order_image}?key=system-large-cover`} width={"50px"} />
                        <Typography sx={Styles.order.typo}>{order.product_name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {order?.quantity}
                    </TableCell>
                    <TableCell sx={Styles.order.cell}>
                      {order?.details?.map((item) =>
                        <Typography sx={Styles.order.desc}>{item.attribute_name} : {item.attribute_value}</Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {order?.statusname}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>


            </Table>
          </TableContainer>
          <Box sx={Styles.order.pagi}>
            <Pagination
              page={page}
              count={pages}
              onChange={handlePageChange}
            />
          </Box>
        </>
      }
    </>
  )
}

export default Orders